import { RemoteSessionsPanel } from "~/features/console/RemoteSessionsPanel";

/** Registry wrapper — the surface itself lives with the rest of the IDE feature. */
export function RemoteSessions() {
  return <RemoteSessionsPanel />;
}
